<template>
  <div
    id="home"
    class="pos_container_panel"
    style="padding-left: 2rem; width: 90%; background-color: white"
  >
    <Loading :loading="submitLoading" />
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-left: 6rem; padding-top: 2rem"
    >
      <el-row style="">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="产品类型" class="form-label-field">
            <el-select
              v-model="searchForm.types"
              clearable
              :label-width="formLabelWidth"
              class="myinput_inner"
            >
              <el-option
                v-for="item in proType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
          <el-form-item label="客户名称" class="form-label-field">
            <el-input
              v-model="searchForm.customerName"
              autocomplete="off"
              :label-width="formLabelWidth"
              @click="showClientNamePop"
              class="myinput_inner"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <el-form-item label="订单号" class="form-label-field">
            <el-input
              v-model="searchForm.orderNumber"
              autocomplete="off"
              class="myinput_inner"
              :label-width="formLabelWidth"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="申请状态" class="form-label-field">
            <el-select
              v-model="searchForm.applyStatus"
              clearable
              :label-width="formLabelWidth"
              class="myinput_inner"
            >
              <el-option
                v-for="item in Status"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
          <el-form-item label="申请日期" class="form-label-field">
            <el-date-picker
              type="date"
              v-model="searchForm.startDate"
              placeholder="yyyy/mm/dd"
              class="myinput_inner"
            ></el-date-picker>
            <span style="padding: 0 5px;">至</span>
            <el-date-picker
              type="date"
              v-model="searchForm.endDate"
              placeholder="yyyy/mm/dd"
              class="myinput_inner"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="grid-content bg-purple-light">
            <el-button type="warning" class="harpIDbtn" @click="Search()">
              搜索</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="tableData"
      style="margin-top: 50px"
      :cell-style="tableCellStyle"
    >
      <el-table-column prop="orderNumber" label="订单号/票号" align="center">
        <template #default="scope">
          <span style="color: blue; cursor: pointer;" @click="showOrder(scope.row)">{{
            scope.row.orderNumber
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="types"
        label="类型"
        align="center"
        :formatter="ProTypeFormat"
      ></el-table-column>
      <el-table-column
        prop="approvalResults"
        label="申请状态"
        align="center"
        :formatter="RefundStatusFormat"
      ></el-table-column>
      <el-table-column
        prop="createdDate"
        label="申请日期"
        align="center"
        :formatter="FormatDateTime"
      ></el-table-column>
      <el-table-column
        prop="refundAmount"
        label="房费退款金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="refundServiceFee"
        label="服务费退款金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="customerName"
        label="客户"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="payChannel"
        label="支付渠道"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" width="132" align="center">
        <template #default="scope">
          <el-button
            type="text"
            v-show="IsFinance && getBtnShow(scope.row)"
            size="small"
            @click="refundBtn(scope.row.id, 2, false)"
            >退款</el-button
          >
          <el-button
            type="text"
            v-show="IsFinance && getBtnShow(scope.row)"
            size="small"
            @click="refundBtn(scope.row.id, 2, true)"
            >线下退款</el-button
          >
          <el-button
            type="text"
            v-show="!IsFinance && getTXBtnShow(scope.row)"
            size="small"
            @click="refundBtn(scope.row.id, 1, false)"
            >通过</el-button
          >
          <el-button
            type="text"
            v-show="getBtnRefuseShow(scope.row)"
            size="small"
            @click="refuseBtn(scope.row.id)"
            >拒绝</el-button
          >
          <el-button
            class="deleteShow"
            @click="openOperationLog(scope.row)"
            type="text"
            size="small"
          >
            操作日志
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 1rem">
      <el-pagination
        class="paginationsty"
        background
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage1"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="searchForm.total"
      />
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList
      :customerDialogVisible="clientListFlag"
      @setCustomerFlag="setCustomerFlag"
      @customerInfo="selectClient"
    ></ClientList>
    <!-- 退款申请详情 -->
    <el-dialog
      title="退款申请详情"
      v-model="isShowRefundDetails"
      width="55rem"
    >
      <el-form size="default" :model="ShowRefundDetails">
        <el-form-item label="酒店返回信息:" :label-width="formLabelWidth">
        </el-form-item>
        <el-form-item label="入住日期:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.actualCheckInDate }}
        </el-form-item>
        <el-form-item label="离店日期:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.actualCheckOutDate }}
        </el-form-item>
        <el-form-item label="应退款房费:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.refundAmount }}
        </el-form-item>
        <el-form-item label="服务费:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.refundServiceFee }}
        </el-form-item>
        <el-form-item label="客人申请信息:" :label-width="formLabelWidth">
        </el-form-item>
        <el-form-item label="入住日期:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.GuestCheckInDate }}
        </el-form-item>
        <el-form-item label="离店日期:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.GuestCheckOutDate }}
        </el-form-item>
        <el-form-item label="退款房费:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.GuestrefundAmount }}
        </el-form-item>
        <el-form-item label="服务费:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.GuestrefundServiceFee }}
        </el-form-item>
        <el-form-item label="备注:" :label-width="formLabelWidth">
          {{ ShowRefundDetails.Guestremark }}
        </el-form-item>
      </el-form>
      <!-- <div
        slot="footer"
        class="dialog-footer"
        v-show="getBtnShow(ShowRefundDetails)"
      >
        <el-button type="primary" @click="ReceiveChangeSave()">退款</el-button>
        <el-button type="primary" @click="refuseBtn()">拒绝</el-button>
      </div> -->
    </el-dialog>
    <!--订单操作日志el-dialog-->
    <el-dialog
      width="98rem"
      class="dialog-one"
      v-model="operationLogInfo.dialogClient"
      :show-close="false"
    >
      <el-tabs v-model="operationLogInfo.clientActiveName" type="card">
        <el-tab-pane label="操作日志" name="first">
          <el-table :data="operationLogInfo.clientData">
            <el-table-column
              prop="CreateDateTime"
              align="center"
              :label="$t('OPERATIONLOG.CreateTime')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="Operation"
              align="center"
              :label="$t('OPERATIONLOG.Operation')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="Description"
              align="center"
              label="备注"
              width="400"
            ></el-table-column>
            <el-table-column
              prop="UserID"
              align="center"
              :label="$t('OPERATIONLOG.CreateById')"
              width="150"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
  
<script>
import ClientList from "@/components/ClientList.vue";
import {
  getrefundlist,
  hoteltradeRefusedrefund,
  hoteltradeAgreerefund,
} from "@/api/bookingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import { formatDateTime } from "@/utils/utils.js";
export default {
  name: "RefundList",
  components: {
    ConfirmBoxs,
    Loading,
    ClientList,
  },
  data() {
    return {
      confirmFlag: false,
      IsFinance: false, //是否为财务列表 true 财务;false TX.
      currentPage1: 1,
      confirmIcon: "",
      confirmMsg: "",
      formLabelWidth: "150px",
      tableData: [],
      searchForm: {
        types: "",
        customerId: "",
        customerName: "",
        orderNumber: "",
        applyStatus: "",
        startDate: "",
        endDate: "",
        total: 0,
      },
      submitLoading: false,
      proType: [
        { value: "全部", key: "" },
        { value: "酒店", key: "JD" },
        { value: "火车", key: "HC" },
        { value: "机票", key: "JP" },
      ],
      Status: [
        { value: "全部", key: "" },
        { key: 1, value: "已提交" },
        { key: 2, value: "审核中" },
        { key: 4, value: "已拒绝" },
        { key: 5, value: "退款中" },
        { key: 6, value: "退款完成" },
        { key: 7, value: "退款失败" },
        { key: 8, value: "线下退款" },
      ],
      ApprovalResults: [
        { value: "全部", key: "" },
        { key: 1, value: "已提交" },
        { key: 2, value: "审核中" },
        { key: 3, value: "审批通过" },
        { key: 4, value: "已拒绝" },
      ],
      RefunStatus: [
        { value: "全部", key: "" },
        { key: 1, value: "退款中" },
        { key: 2, value: "退款完成" },
      ],
      clientListFlag: false,
      isShowRefundDetails: false, //是否展示退款详情弹框
      ShowRefundDetails: {
        actualCheckInDate: "", //实际入店时间
        actualCheckOutDate: "", //实际离店时间
        refundAmount: "", //应退款金额
        refundServiceFee: "", //应退款服务费
        GuestCheckInDate: "", //客人填写入住时间
        GuestCheckOutDate: "", //客人填写离店时间
        GuestrefundAmount: "", //客人填写退款房费
        GuestrefundServiceFee: "", //客人填写退款服务费
        Guestremark: "", //备注
        approvalResults: "",
      },
      selectRefundId: 0,
      operationLogInfo: {
        operationLogloading: true,
        dialogClient: false,
        clientActiveName: "first",
        clientData: [],
      },
    };
  },
  computed: {
    getBtnShow() {
      return (item) => {
        if (
          item.approvalResults == 1 ||
          item.approvalResults == 2 ||
          (item.approvalResults == 3 && item.refunStatus != 2)
        ) {
          return true;
        } else {
          return false;
        }
      };
    },
    getTXBtnShow() {
      return (item) => {
        if (item.approvalResults == 1 || item.approvalResults == 2) {
          return true;
        } else {
          return false;
        }
      };
    },
    getBtnRefuseShow() {
      return (item) => {
        if (item.approvalResults == 1 || item.approvalResults == 2) {
          return true;
        } else {
          return false;
        }
      };
    },
  },
  mounted() {
    this.searchForm.startDate = new Date(
      new Date().setDate(new Date().getDate() - 14)
    ).toLocaleDateString();
    this.searchForm.endDate = new Date().toLocaleDateString();
    if (Object.prototype.hasOwnProperty.call(this.$route.query, "IsFinance")) {
      if (
        this.$route.query.IsFinance != undefined &&
        this.$route.query.IsFinance != "" &&
        this.$route.query.IsFinance != null
      ) {
        this.IsFinance = this.$route.query.IsFinance;
      }
    }
    this.Search();
  },
  methods: {
    tableCellStyle({ columnIndex }) {
      if (columnIndex === 0) {
        return {
          cursor: 'pointer'
        }
      }
    },
    FormatDateTime(value) {
      return formatDateTime(value.createdDate, "YYYY-MM-DD HH:mm:ss");
    },
    //类型
    ProTypeFormat(value) {
      if (
        value.types != null &&
        value.types != undefined &&
        value.types != ""
      ) {
        let arr_value = this.proType.filter((p) => p.key == value.types.trim());
        if (arr_value.length > 0) {
          return arr_value[0].value;
        }
      } else {
        return "";
      }
    },
    //状态
    RefundStatusFormat(value) {
      //判断是否审批通过 审批通过展示退款状态
      if (value.approvalResults == 3) {
        let refund_value = this.RefunStatus.filter(
          (p) => p.key == value.refunStatus
        );
        if (value.refunStatus == 2 && value.isOffline) {
          return "线下退款";
        }
        if (value.refunStatus == 1 && value.refundCount > 0) {
          return "退款失败";
        }
        if (refund_value.length > 0) {
          return refund_value[0].value;
        }
      }
      let arr_value = this.ApprovalResults.filter(
        (p) => p.key == value.approvalResults
      );
      if (arr_value.length > 0) {
        return arr_value[0].value;
      }
      return "";
    },
    handleCurrentChange(val) {
      this.Search(val);
    },
    //搜索button
    async Search(int) {
      this.submitLoading = true;
      let searchparams = {
        pageNum: int ? int : 1,
        pageSize: 15,
        types: this.searchForm.types,
        customerId: this.searchForm.customerId,
        customerName: this.searchForm.customerName,
        orderNumber: this.searchForm.orderNumber,
        applyStatus: this.searchForm.applyStatus,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        finance: this.IsFinance,
      };
      await getrefundlist(searchparams)
        .then((res) => {
          this.submitLoading = false;
          this.tableData = res.data.list;
          this.searchForm.total = res.data.pagination.total;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //搜索点击客户名称弹出选择客户
    showClientNamePop() {
      this.isPosAdd = false;
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.searchForm.customerName = item.customerName;
      this.searchForm.customerId = item.customerCode;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    //拒绝请求
    refuseBtn(id) {
      this.selectRefundId = 0;
      this.selectRefundId = id;
      this.$confirm("是否拒绝次退款申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          let params = {
            params: {
              refundid: this.selectRefundId,
            },
          };
          await hoteltradeRefusedrefund(params)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "拒绝成功!",
                });
                this.Search(this.currentPage1);
              } else {
                this.$message({
                  type: "error",
                  message: "拒绝失败,请重新尝试!",
                });
              }
            })
            .catch(function (error) {
              this.submitLoading = false;
              console.log("请求失败", error.objError);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //申请退款
    refundBtn(id, type, IsOffline) {
      this.selectRefundId = 0;
      this.selectRefundId = id;
      this.$confirm("是否通过这次申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          let params = {
            params: {
              refundid: this.selectRefundId,
              type: type,
              isOffline: IsOffline,
            },
          };
          await hoteltradeAgreerefund(params)
            .then((res) => {
              if (res.code == 200) {
                if(res.data){
                  this.$message({
                    type: "success",
                    message: type == "1" ? "审批通过" : "退款成功!",
                  });
                }else{
                  this.$message({
                    type: "error",
                    message: type == "1" ? "审批未通过" : "退款失败!",
                  });
                }
                this.Search(this.currentPage1);
              } else {
                this.$message({
                  type: "error",
                  message: "操作失败,请重新尝试!",
                });
              }
            })
            .catch(function (error) {
              this.submitLoading = false;
              console.log("请求失败", error.objError);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    showOrder(value) {
      this.selectRefundId = 0;
      this.selectRefundId = value.id;
      //酒店实际入离日期
      if (
        Object.prototype.hasOwnProperty.call(value, "actualCheckInDateBySystem")
      ) {
        this.ShowRefundDetails.actualCheckInDate = formatDateTime(
          value.actualCheckInDateBySystem,
          "YYYY-MM-DD"
        );
      }
      if (Object.prototype.hasOwnProperty.call(value,"actualCheckOutDateBySystem")) {
        this.ShowRefundDetails.actualCheckOutDate = formatDateTime(value.actualCheckOutDateBySystem,"YYYY-MM-DD");
      }
      this.ShowRefundDetails.refundAmount = value.refundAmountCalc;
      this.ShowRefundDetails.refundServiceFee = value.refundServiceFee;
      // 客人填写入离日期
      if (Object.prototype.hasOwnProperty.call(value, "actualCheckInDate")) {
        this.ShowRefundDetails.GuestCheckInDate = formatDateTime(value.actualCheckInDate,"YYYY-MM-DD");
      }
      if (Object.prototype.hasOwnProperty.call(value, "actualCheckOutDate")) {
        this.ShowRefundDetails.GuestCheckOutDate = formatDateTime(value.actualCheckOutDate,"YYYY-MM-DD");
      }

      this.ShowRefundDetails.GuestrefundAmount = value.refundAmount;
      this.ShowRefundDetails.GuestrefundServiceFee = value.refundServiceFee;
      this.ShowRefundDetails.Guestremark = value.refundReason;
      //this.ShowRefundDetails.approvalResults=value.approvalResults;
      this.isShowRefundDetails = true;
    },
    async openOperationLog(row) {
      var arrTemp = [];
      this.operationLogInfo.dialogClient = true;
      if (row.refundRecordsList != null) {
        for (var i = 0; i < row.refundRecordsList.length; i++) {
          var response = row.refundRecordsList[i];
          let statusFormat = { approvalResults: response.applyStatus };
          const item = {
            CreateDateTime: formatDateTime(response.submissionTime,"YYYY-MM-DD HH:mm:ss"),
            Description: response.remark,
            UserID: response.applicant,
            Operation: this.RefundStatusFormat(statusFormat),
          };
          arrTemp.push(item);
        }
      }
      this.operationLogInfo.clientData = arrTemp;
    },
  },
};
</script>
 <style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
.myinput_inner {
  height: 2.7rem;
  border-radius: 0;
  width: 18vw;
  /* margin-top: 1rem; */
}
</style>
  